import React, { useEffect, useState, FC } from 'react'
import { Allocation } from './types'
import { Container, LoadingContainer } from './styles'
import AllocationCard from './AllocationCard'
import NoAllocations from './NoAllocations'
import AnimatedLoader from '../../../shared_components/AnimatedLoader'
import { setIsLaunch } from '../../../modules/miscUi/actions'
import { useDispatch } from 'react-redux'

interface Props {
  allocations: Allocation[]
  fetchingVendings: boolean
}

const Allocations: FC<Props> = ({ allocations, fetchingVendings }) => {
  const dispatch = useDispatch()

  const [openTabs, setOpenTabs] = useState<number[]>(
    allocations.slice(0, 3).map((_, i) => i),
  )

  useEffect(() => {
    setOpenTabs([...allocations.slice(0, 3).map((_, i) => i)])
  }, [allocations])

  useEffect(() => {
    dispatch(setIsLaunch(false))
  }, [dispatch])

  return (
    <Container>
      {fetchingVendings ? (
        <LoadingContainer>
          <AnimatedLoader size={80} onlyWhite />
        </LoadingContainer>
      ) : allocations.length === 0 ? (
        <NoAllocations />
      ) : (
        allocations
          .sort((a: Allocation, b: Allocation) => {
            if (
              !Boolean(a?.pool?.privateSale?.start) ||
              !Boolean(b?.pool?.privateSale?.start)
            )
              return 0

            return (
              new Date(b?.pool?.privateSale?.start ?? 0).getTime() -
              new Date(a?.pool?.privateSale?.start ?? 0).getTime()
            )
          })
          .sort((a, b) => b?.count - a?.count)
          .map((allocation, i) => (
            <AllocationCard
              openTabs={openTabs}
              setOpenTabs={setOpenTabs}
              allocation={allocation}
              key={`allocation-card-${i}`}
              i={i}
            />
          ))
      )}
    </Container>
  )
}

export default Allocations
